import { RenderClearFlag } from "../../../RenderEngine/RenderEnum/RenderClearFlag";
import { Shader3D } from "../../../RenderEngine/RenderShader/Shader3D";
import { LayaGL } from "../../../layagl/LayaGL";
import { StatElement } from "../../../layagl/StatisticsContext";
import { Color } from "../../../maths/Color";
import { WebGLEngine } from "../RenderDevice/WebGLEngine";
export class WebglRenderContext2D {
    constructor() {
        this._clearColor = new Color(0, 0, 0, 0);
        this.invertY = false;
        this.pipelineMode = "Forward";
        this._prevTypeKey = -1;
        this._prevTextureKey = -1;
        this._prevClip = null;
        this._prevShaderIns = null;
        this._globalAlpha = -1;
        this._globalConfigShaderData = Shader3D._configDefineValues;
    }
    drawRenderElementList(list) {
        let time = performance.now();
        for (var i = 0, n = list.length; i < n; i++) {
            let element = list.elements[i];
            element._prepare(this);
        }
        LayaGL.statAgent.recordTimeData(StatElement.T_2DContextPre, performance.now() - time);
        time = performance.now();
        this._prevTypeKey = -1;
        this._prevTextureKey = -1;
        this._prevClip = null;
        this._prevShaderIns = null;
        for (var i = 0, n = list.length; i < n; i++) {
            list.elements[i]._render(this);
        }
        LayaGL.statAgent.recordCTData(StatElement.CT_2DDrawCall, list.length);
        LayaGL.statAgent.recordTimeData(StatElement.T_2DContextRender, performance.now() - time);
        LayaGL.renderEngine._framePassCount++;
        return 0;
    }
    setOffscreenView(width, height) {
        this._offscreenWidth = width;
        this._offscreenHeight = height;
    }
    setRenderTarget(value, clear, clearColor) {
        this._destRT = value;
        clearColor.cloneTo(this._clearColor);
        if (this._destRT) {
            WebGLEngine.instance.getTextureContext().bindRenderTarget(this._destRT);
            WebGLEngine.instance.viewport(0, 0, this._destRT._textures[0].width, this._destRT._textures[0].height);
        }
        else {
            WebGLEngine.instance.getTextureContext().bindoutScreenTarget();
            WebGLEngine.instance.viewport(0, 0, this._offscreenWidth, this._offscreenHeight);
        }
        WebGLEngine.instance.scissorTest(false);
        WebGLEngine.instance.clearRenderTexture(clear ? RenderClearFlag.Color : RenderClearFlag.Nothing, this._clearColor);
    }
    getRenderTarget() {
        return this._destRT;
    }
    drawRenderElementOne(node) {
        node._prepare(this);
        node._render(this);
        LayaGL.statAgent.recordCTData(StatElement.CT_2DDrawCall, 1);
        LayaGL.renderEngine._framePassCount++;
    }
    runOneCMD(cmd) {
        cmd.apply(this);
    }
    runCMDList(cmds) {
        cmds.forEach(element => {
            element.apply(this);
        });
    }
}
